import React from 'react';
import { Text } from 'library';
import { JobModel } from '../NewsfeedModels';
import JobCardAvatarBase from './JobCardAvatarBase';
import { Grid } from '@material-ui/core';
import { isMobile } from 'react-device-detect';

const JobCardAvatar = ({ job }: { job: JobModel }) => {
    const familyActivity = () => {
        return job.family.user.last_active ? (
            <Grid container direction="column" alignItems="center" justify="center">
                <Text variant="body1" bold textStyle={{ ...styles.family, marginTop: 4 }}>
                    Active
                </Text>
                <Text variant="body1" bold textStyle={styles.family}>
                    {job.family.user.last_active}
                </Text>
            </Grid>
        ) : null;
    };

    return <JobCardAvatarBase job={job} caption={!job.requested ? familyActivity() : null} />;
};

export default JobCardAvatar;

const styles = {
    family: {
        fontSize: 12,
        lineHeight: '12pt',
        letterSpacing: isMobile ? '-1px' : '1px',
    },
};
